import { decodeText } from '@aytm/app/stats/lib/util/helpers'
import {
  removeTagsFromText,
  removeLogicFromText
} from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/textUtils'

// port of page.lib.decodeHtmlCharCodes — the `{ decode: true }` option of the coffee
// removeTagsFromText has no JS twin
const decodeHtmlCharCodes = (text = '') =>
  String(text).replace(/(&#(\d+);)/g, (match, capture, charCode) => String.fromCharCode(charCode))

// svg:title is a textContent sink — decode + strip logic/tags so an "&amp;" name
// shows as "&" not literally
export const sectionTitle = (text = '') =>
  decodeText(decodeHtmlCharCodes(removeTagsFromText(removeLogicFromText(text || ''))))
